import type * as Types from '../../../schemas/shopify/admin.types';

export type CollectionAnalyticPageInfoNodeFragment = Pick<
  Types.Collection,
  'id' | 'title' | 'handle'
>;

export const CollectionAnalyticPageInfoNodeFragmentDoc = `
    fragment CollectionAnalyticPageInfoNode on Collection {
  id
  title
  handle
}
    `;
